import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from '@angular/router';
import { VisualIdentificationComponent } from './visual-identification.component';
import { SelectableBorderComponent } from "./selectable-border/selectable-border.component";
import { ImagePredictionComponent } from "./image-prediction/image-prediction.component";
import { ReceiptViewerComponent } from "./receipt-viewer/receipt-viewer.component";
import { PredictResultComponent } from "./predict-result/predict-result.component";

const routes: Routes = [
    {
        path: '',
        component: VisualIdentificationComponent,        
        children:[
            {
                path: 'predictresultold/:id',
                component: SelectableBorderComponent,
                data: { preload : true },
            },
            {
                path: 'predictresult/:id/:b',
                component: PredictResultComponent,
                data: { preload : true },
            },
            {
                path: 'imageprediction',
                component: ImagePredictionComponent,
                data: { preload : true },
            },
            {
                path: 'receiptviewer/:id',
                component: ReceiptViewerComponent,
                data: { preload : true },
            }
        ]
    }
]

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
    ],
    exports: [RouterModule],
})
export class VisualIdentificationRoutingModule {}